import PropTypes from "prop-types";
import { Typography, Button } from "@cea/ui-kit";
import { useContext } from "react";

import LogoImage from "../../assets/itk-cea-full-logo.png";
import LoginCoverImage from "../../assets/login-cover.jpg";
import MicrosoftLogoImage from "../../assets/microsoft-logo.png";
import AuthContext from "../../contexts/AuthContext";

import classes from "./login.module.css";

const { Title } = Typography;

const Login = () => {
  const { handleLogin, loading } = useContext(AuthContext);

  return (
    <div className={classes.container}>
      <div
        className={classes.background}
        style={{
          backgroundImage: `url(${LoginCoverImage})`,
        }}
      />

      <div className={classes.card}>
        <img src={LogoImage} alt="Intertek CEA Logo" className={classes.logo} />

        <Title level={3} className={classes.title}>
          Welcome Back
        </Title>

        <div className={classes.subtitle}>
          Sign in to access the Intertek CEA
          <br />
          Admin Portal
        </div>

        <Button
          className={classes.button}
          onClick={handleLogin}
          disabled={loading}
          loading={loading}
        >
          {/* Only show icon if not loading, or standard behavior */}
          {!loading && <img src={MicrosoftLogoImage} alt="Microsoft" />}
          Continue with Microsoft
        </Button>

        <div className={classes.footer}>
          &copy; {new Date().getFullYear()} Intertek CEA. All rights reserved.
        </div>
      </div>
    </div>
  );
};

Login.propTypes = {
  history: PropTypes.object,
};

export default Login;
